import React, {memo} from "react";
import ListItem from "./ListItem";

function ListGroup(props) {
    const { type, items } = props;

    if (items.length === 0)
        return null;
    return (
        <div className="list-item-group">
            <div className="group-heading-row">
                <div className="group-heading-text">{type}</div>
            </div>
            {items.map(item => <ListItem item={item} key={item.id} />)}
        </div>
    );
}
export default memo(ListGroup);
